export const sort = [
  { label: "ID", name: "id", sortable: false },
  { label: "Nazwa", name: "name", sortable: false },
  {
    label: "Identifikator",
    name: "identifier",

    sortable: false,
  },
  {
    label: "Pozycja",
    name: "position",

    sortable: false,
  },
  {
    label: "Magazyn",
    name: "warehouse_name",
    sortable: false,
  },
  {
    label: "Pomieszczenie",
    name: "warehouse_room_name",

    sortable: false,
  },
];

// WarehouseAisle.order(position: :asc).each.with_index(1) do |record, index|
//   record.update_column(:position, index)
// end
